import React,{ Component } from 'react';

import './IngestionStatus.css';
import Spinner from '@acri-tools/react-tools/components/Spinner/Spinner';

import classNames from 'classnames';
import request from '@acri-tools/react-tools/utils/request';

import { axiosErrorHandler, toast_request_error } from '@acri-tools/react-tools/utils/global';
import parse from 'csv-parse/lib/sync';

import { format_bytes, get_data_file_url } from '../../../../utils/data';
import StatusBar from '../../../../components/StatusBar/StatusBar';


interface Props{
}
interface State{
    loading: boolean

    data?:any
}


const data_object = (row:Array<any>) =>{
    return {
        name: row[2],
        size: parseFloat(row[3]),
        nb_prod: parseFloat(row[4]),
        s_disk: parseFloat(row[5]),
        s_tape: parseFloat(row[6]),
        s_sent: parseFloat(row[7]),
        s_archived: parseFloat(row[8]),
        p_disk: parseFloat(row[9]),
        p_tape: parseFloat(row[10]),
        p_sent: parseFloat(row[11]),
        p_archived: parseFloat(row[12]),
        sub: []
    }
}

const add_data = (depth:number, parent:any, row:Array<any>) =>{
    if(depth === 0){
        parent.sub.push(data_object(row))
    }
    else{
        add_data(depth - 1, parent.sub[parent.sub.length - 1], row);
    }
}

export default class IngestionStatus extends Component<Props,State>{
    constructor(props:Props){
        super(props);
        this.state={
            loading: false,
        }
    }

    componentDidMount(){
        this.fetch_data()
    }


    fetch_data = async() =>{
        this.setState({ loading: true });
        try{
            let res = await request(get_data_file_url(`ingestion_status_del.csv`),{
            // let res = await request(`${API_URL}/api/user-manager/v1/files/media/ingestion_dataset_detail_v2.csv`,{
                method: 'get'
            })

            // console.log('dfsd', res.data)
            let csv_data = parse(res.data, { delimiter: ';' });
            
            let headers = csv_data.shift();
            let total = csv_data.shift();

            let data:any = { ...data_object(total), open:true };
            // console.debug("data", data);

            for(let d of csv_data){
                // rheader<DEPTH>
                let depth = d[0].split('rheader')[1];
                depth = parseInt(depth);
                add_data(depth - 1, data, d);
            }
            // console.debug("data", data);

            this.setState({ data });
        }
        catch(e:any){
            axiosErrorHandler(e, { functionName: `fetch_data` });
            toast_request_error(e);
        }
        finally{
            this.setState({ loading:false })
        } 
    }


    render(){
        return (
            <div className="ingestion-status">
                {
                    this.state.data &&
                    <>  
                        <div className="ingestion-status-data-info header" >
                            <div className="ingestion-status-name"></div>
                            <div className="ingestion-status-size">
                                Size
                            </div>
                            <div className="ingestion-status-products">
                                N° of products
                            </div>
                            <div className="ingestion-status-status-size ingestion-status-bar">
                                Status by size
                            </div>
                            <div className="ingestion-status-status-size ingestion-status-bar">
                                Status by n° of products
                            </div>
                        </div>
                        <div className="ingestion-status-values">
                            { this.get_data(this.state.data, 0) }
                        </div>
                    </>
                }
            </div>
        );
    }

    get_data = (data:any, depth:number) =>{
        let has_sub = data.sub.length > 0;
        return (
            <div
                className={`ingestion-status-data depth-${depth}`}
            >
                <div
                    className={classNames({ 
                        "ingestion-status-data-info":true, 
                        "has-sub": has_sub
                    })}
                    onClick={()=>{
                        if(has_sub){
                            data.open = !data.open;
                            this.forceUpdate();
                        }
                    }}
                >
                    {
                        has_sub &&
                        <div 
                            className={classNames({ 
                                "ingestion-status-toggle":true, 
                                "toggled": !!data.open
                            })}
                        >
                            <i className="fas fa-chevron-left"/>
                        </div>
                    }
                    <div className="ingestion-status-name">
                        { data.name }
                    </div>
                    <div className="ingestion-status-size">
                        { format_bytes(data.size * Math.pow(1000, 3), { base: 1000 }) }
                    </div>
                    <div className="ingestion-status-products">
                        { data.nb_prod }
                    </div>
                    <div className="ingestion-status-status-size ingestion-status-bar">
                        <StatusBar
                            archived={data.s_archived}
                            sent={data.s_sent}
                            tape={data.s_tape}
                            disk={data.s_disk}
                        />
                    </div>
                    <div className="ingestion-status-status-size ingestion-status-bar">
                        <StatusBar
                            archived={data.p_archived}
                            sent={data.p_sent}
                            tape={data.p_tape}
                            disk={data.p_disk}
                        />
                    </div>
                </div>
                {
                    data.open &&
                    <div className="ingestion-status-sub-data">
                        {
                            data.sub.map((sub_data:any)=>(
                                this.get_data(sub_data, depth + 1)
                            ))
                        }
                    </div>
                }
            </div>
        )
    }

};
